import { render, staticRenderFns } from "./imageUploader.vue?vue&type=template&id=2ee47839&scoped=true"
import script from "./imageUploader.vue?vue&type=script&lang=js"
export * from "./imageUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee47839",
  null
  
)

export default component.exports